import { Row, Column, LeftHandNavigation, Typography, LinkList, ListItem, Divider, Box } from '@vp/swan'
import './RelatedArticles.scss'
import { useTranslation } from 'react-i18next'
import { RelatedArticle } from '../../types/article.type'

interface RelatedArticlesProps {
  tenant: string
  locale: string
  relatedArticles: RelatedArticle[]
}
export const RelatedArticles = (props: RelatedArticlesProps) => {
  const { relatedArticles, locale, tenant } = props
  const { t } = useTranslation(tenant)
  const lng = locale.toLowerCase().replace('-', '_')
  return (
    <aside aria-labelledby="relatedArticles">
      <Row className="related-articles-container">
        <Column span={12} spanXs={12}>
          <LeftHandNavigation>
            <Typography fontSkin="title-subsection">
              {' '}
              {t(`${tenant}:articles.related_articles.title`, {
                lng,
              })}
            </Typography>
            <LinkList marginTop={9}>
              {relatedArticles.map((article, index) => {
                return (
                  <ListItem key={`related-articles-${index}`}>
                    <a href={article.articleUrl}>{article.articleTitle}</a>
                    <Divider />
                    {index !== relatedArticles.length ? (
                      <>
                        <Box display={{ lg: 'none', md: 'none', sm: 'none' }} mb="5" />
                        <Box display={{ xs: 'none', md: 'block', sm: 'none' }} mb="6" />
                      </>
                    ) : null}
                  </ListItem>
                )
              })}
            </LinkList>
          </LeftHandNavigation>
        </Column>
      </Row>
    </aside>
  )
}
